import React from 'react';
import PropTypes from 'prop-types';
import OfficePageLettersItem from './OfficePageLettersItem';
import Styles from './OfficePageLetters.scss';
import size from 'lodash/size';
import first from 'lodash/first';

const OfficePageLetters = ({ items, setActiveItem, activeItem }) => {
  const firstRender = React.useRef(true);

  React.useEffect(() => {
    if (!firstRender.current) {
      setActiveItem(first(items));
    }
    firstRender.current = false;
  }, [items, setActiveItem]);

  if (size(items) === 1) {
    return null;
  }

  return (
    <div className={Styles.letters}>
      {items.map((item) => (
        <OfficePageLettersItem
          key={item}
          item={item}
          isActive={activeItem === item}
          onClick={() => setActiveItem(item)}
        />
      ))}
    </div>
  );
};

OfficePageLetters.propTypes = {
  items: PropTypes.array,
  activeItem: PropTypes.string,
  setActiveItem: PropTypes.func,
};

export default OfficePageLetters;
